import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';


const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = {
}

export const MemoForm = connect(mapStateToProps, mapDispatchToProps)(React.createClass({
  getInitialState(){
    return {
      memo: ''
    }
  },

  componentWillReceiveProps(nextProps) {
    this.setState({'memo': nextProps.memo})
  },

  setMemoValue(m) {
    this.setState({'memo': m})
  },

  setMemo(e) {
    this.setState({'memo': e.target.value})
  },

  submit(e) {
    e.preventDefault()
    this.props.save_memo(this.state.memo)
    .then(()=>{
      this.props.close()
    })
  },

  render() {
    return (
      <div>
        <Modal show={this.props.showModal} onHide={this.props.close}>
          <form className='usermemoform' method='POST' autocomplete>

            <Modal.Header closeButton>
              <Modal.Title>{this.props.title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <label>メモ:</label>
              <textarea className="form-control input-memo" placeholder="自由なメモを書き込めます" autofocus
                onChange={this.setMemo} value={this.state.memo}/>
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={this.props.close}>キャンセル</Button>
              <Button type='submit' class='btn btn-primary'
                onClick={this.submit}>保存</Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}))



// WEBPACK FOOTER //
// ./components/memo.react.js